export const CHttpStatusCodes = {
    NETWORK_ERROR: 0
} as const;